<!-- <div class="annual-discount" *ngIf="!intervalState">
  Pay annually and save 15%<br>
  <i class="fa fa-long-arrow-down m-t-5"></i>
</div> -->
<qw-toggle-switch class="interval-toggle" [toggleValue]="!intervalState" (toggleValueChange)="toggleInterval($event)">
  <!-- <span class="toggle-switch left">Pay annually</span> -->
  <p class="toggle-switch right">Pay {{ intervalState ? 'annually' : 'monthly'}}</p>
</qw-toggle-switch>